import actionCreatorFactory from "typescript-fsa";
import { FileMenuRequestBody, FileMenuResponse } from "../../core/api/requests/file/menu/types";
import { FileRegistrationResultRequestBody, FileRegistrationResultResponse } from "../../core/api/requests/file/registration_results/types";
import { MaintenanceRequestBody, MaintenanceResponse } from "../../core/api/requests/maintenance/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@Data");

export const dataActions = {
  getMenus: actionCreator.async<CommonAsyncType & FileMenuRequestBody, FileMenuResponse>("GET_DATA_MENUS"),
  getMaintenanceJson: actionCreator.async<CommonAsyncType & MaintenanceRequestBody, MaintenanceResponse>("GET_MAINTENANCE_JSON"),
  getRegistrationResults: actionCreator.async<CommonAsyncType & FileRegistrationResultRequestBody, FileRegistrationResultResponse>(
    "GET_DATA_REGISTRATION_RESULTS",
  ),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
